import { Button, Modal, ModalContent, ModalTitle, ModalContentText, ModalActions } from '@deere/fuel-react'
import React from 'react'

export const TPSModal = ({showModal, setShowModal, labelBtnPrimary, handleSubmit,modalMessage, titleModal}) => {
  
    function onClose(){
        setShowModal(false)
    }
  
    return (
    <div>
      <Modal
        open={showModal}
        onClose={onClose}
        aria-labelledby="alert-Modal-title"
        aria-describedby="alert-Modal-description"
      >
        <ModalTitle id="alert-Modal-title">{titleModal}</ModalTitle>
        <ModalContent>
          <ModalContentText id="alert-Modal-description" sx={{textAlign:"justify"}}>
            {modalMessage}
          </ModalContentText>
        </ModalContent>
        <ModalActions>
          <Button onClick={onClose} variant="primary">
           {labelBtnPrimary}
          </Button>
        </ModalActions>
      </Modal>
    </div>
  )
}